/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { ProductChangeLanguageChoose } from './ProductChangeLanguageChoose';

type ProductChangeLanguageType = {
    product: SimCardInterface;
    reload(languageId?: number | null): void;
    classes: any;
    isCreate?: boolean;
};

export const ProductChangeLanguage: FunctionComponent<ProductChangeLanguageType> = ({ product, reload, isCreate }): ReactElement => {
    const [changeProfileOpen, setChangeProfileOpen] = useState(false);

    return (
        <>
            <CustomTextButtom
                callback={(): void => setChangeProfileOpen(true)}
                callbackParam={{}}
                label={'simcard:language.change_language_button'}
                size="sm"
            />
            <ProductChangeLanguageChoose
                open={changeProfileOpen}
                close={(): void => {
                    setChangeProfileOpen(false);
                }}
                product={product}
                reload={reload}
                isCreate={isCreate ?? false}
            />
        </>
    );
};
